import Vue from 'vue'
import Vuex from 'vuex'

import hero from './modules/hero'
import duty from './modules/duty'
import showcase from './modules/showcase'
import team from './modules/team'
import gallery from './modules/gallery'
import contact from './modules/contact'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		hero,
		duty,
		showcase,
		team,
		gallery,
		contact
	},

	state: {
		consoleInfoStyle: 'background-color:green;color:white;padding:6px;'
	}
})
